// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"adb059cc","453":"caa34fd2","455":"741d8038","977":"d9b953db"}[chunkId] + ".chunk.js";
};